import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as modal from "../util/modal.ts";
import * as Medias from "../server/Medias.ts";

import * as i18n from "../i18n.ts";
import { validate } from "../util/forms.ts";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as FeatureSeen from "../util/FeatureSeen.ts";
import {ControllerBook} from "../page/ControllerBook.ts";

import {FilerTreeCache} from "../server/objects/FilerBeans.ts"
import * as fileViewer from "./fileViewer.ts"

import TPL_folder_list from "./folder_list.mustache";
import TPL_folder_content from "./folder_content.mustache";
import Icons from "../svg/Icons.ts";
import {upload} from "./filer_dragdrop.ts";
import { pickFileFromDevice } from "../lib/FileUtils.ts";
import { pickFolder } from "./filerModal.ts";
import { sameSet } from "../lib/ArrayUtil.ts";
import { isFeatureEnabled } from "../lib/launchdarkly/launchdarkly.ts";
import MultiplexApi from "../server/MultiplexApi.ts"
import { type FilerDisplayModeEnum, type FilerSortingEnum, FolderBean, FolderInputBean, IFilerInputBean } from "../server/fizapilib.auto.ts";




INR.onPage(INR.URL.FILER,function(){
  if(FwDatas.getPermission('filer')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }

  //check first onboarding
  if(!FeatureSeen.hasSeen('filer.onboarding')){
    FeatureSeen.markSeen('filer.onboarding');
    modal.askAsPromise({
      title:'files.onboarding1.title',
      message:'files.onboarding1.message',
      lottie:"images/lottie/anim_files_tutorial_top_easy_sharing.json",
      mediaSize:160,
      button:[
        {title:"actions.next",onclick:open2},
        {title:"actions.skip",class:"secondary"}
      ]
    })
    function open2(){
      modal.closeDomModal();
      modal.askAsPromise({
        title:'files.onboarding2.title',
        message:'files.onboarding2.message',
        lottie:"images/lottie/anim_files_tutorial_top_folder_color.json",
        mediaSize:160,
        button:[
          {title:"actions.next",onclick:open3},
          {title:"actions.skip",class:"secondary"}
        ]
      })
    }
    function open3(){
      modal.closeDomModal();
      modal.askAsPromise({
        title:'files.onboarding3.title',
        message:'files.onboarding3.message',
        lottie:"images/lottie/anim_files_tutorial_top_access_control.json",
        mediaSize:160,
        button:[
          {title:"actions.start"}
        ]
      })
    }
  }else if(!FeatureSeen.hasSeen('filer.subfolder')){
    FeatureSeen.markSeen('filer.subfolder');
    modal.askAsPromise({
      title:'files.promosubfolder.title',
      message:'files.promosubfolder.message',
      image:"images/introducing_subfolder.svg",
      mediaSize:100,
      button:[
        {title:"actions.gotit"}
      ]
    })
  }
  var CONTROLLER = new ControllerBook(document.querySelector('.pane-left'),TPL_folder_list,document.querySelector('.pane-main'),TPL_folder_content,undefined,FilerTreeCache,function(rootFolder){
    return rootFolder;
  });
  INR.subscribe("filerNeedRefresh mediaDeleted",()=>CONTROLLER.refresh())
  amplify.publish("handleParam");
});
actionMenu.register({
  foldermenu(){
    const
      metaId = Html.getDomMetaId(this),
      folder = FilerTreeCache.get(metaId) as FolderBean,
      buttons = [];

    if(folder.parentFolderId!==undefined){
      buttons.push({onclick:'fileupload',svg:Icons.filer.ic_upload,i18nkey:'files.upload'})
      buttons.push({onclick:'foldercreate|'+metaId,svg:Icons.filer.ic_folder_add,i18nkey:'files.createfolder'})
      buttons.push({html:'<hr/>'})
    }

    if(folder.rights.canUpdate){
      buttons.push({onclick:'folderedit',svg:Icons.ic_settings,i18nkey:'files.foldersettings'})
    }
    const isMainView = !this.matches('.filer-grid *')
    if(isMainView){
      buttons.push({onclick:'togglemenu',svg:Icons.ic_sort,i18nkey:'catsystem.sort.title',
        submenu:[
          {onclick:'foldersort|alphabetical'            , svg:Icons.ic_arrow_down,i18nkey:'files.settings_sort_option.name_a_to_z',svgend:folder.filerSorting==='alphabetical'?Icons.ic_checkmark:undefined},
          {onclick:'foldersort|alphabeticalReverse'     , svg:Icons.ic_arrow_up,i18nkey:'files.settings_sort_option.name_z_to_a',svgend:folder.filerSorting==='alphabeticalReverse'?Icons.ic_checkmark:undefined},
          {onclick:'foldersort|modificationDateReverse' , svg:Icons.clock.ic_access_time,i18nkey:'files.settings_sort_option.modif_date_new',svgend:folder.filerSorting==='modificationDateReverse'?Icons.ic_checkmark:undefined},
          {onclick:'foldersort|modificationDate'        , svg:Icons.clock.ic_access_time_variant,i18nkey:'files.settings_sort_option.modif_date_old',svgend:folder.filerSorting==='modificationDate'?Icons.ic_checkmark:undefined},
        ]})

    }
    if(folder.parentFolderId){
      if(isMainView){
        buttons.push({onclick:'togglemenu',svg:Icons.ic_list_grid,i18nkey:'files.settings_display_mode.title',
          submenu:[
            {onclick:'folderview|GRID',svg:Icons.ic_list_grid,i18nkey:'files.settings_display_mode.grid',svgend:folder.filerDisplayMode==='GRID'?Icons.ic_checkmark:undefined},
            {onclick:'folderview|LIST',svg:Icons.ic_list_row,i18nkey:'files.settings_display_mode.list',svgend:folder.filerDisplayMode==='LIST'?Icons.ic_checkmark:undefined}
          ]
        })
      }
    }else{
      buttons.push({onclick:'fileropenfeedback',svg:Icons.ic_comment,i18nkey:'actions.feedback'})
    }
    buttons.push({html:'<hr/>'})
    if(folder.parentFolderId){
      if(folder.rights.canUpdate){
      	buttons.push({onclick:'foldermove',svg:Icons.filer.ic_file_move,i18nkey:'actions.move'})
      }
      buttons.push({onclick:'folderduplicate',svg:Icons.ic_duplicate,i18nkey:'actions.duplicate'})
    }

    buttons.push({svg:Icons.ic_download,onclick:"mediadownload",i18nkey:'actions.download'});

    if(folder.parentFolderId!==undefined){
      if(folder.rights.canDelete){
        buttons.push({onclick:'folderdelete',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }else{
        buttons.push({onclick:'notadminmodal',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }
    }
    return {'menu':buttons}
  },
  fabaddinfolder(){
    const
      metaId = Html.getDomMetaId(this),
      buttons = [];

    buttons.push({onclick:'fileupload',svg:Icons.filer.ic_upload,i18nkey:'files.upload'})
    buttons.push({onclick:'foldercreate|'+metaId,svg:Icons.filer.ic_folder_add,i18nkey:'files.createfolder'})
    return {'menu':buttons}
  },
  parentfolders(){
    const
      metaId = Html.getDomMetaId(this),
      buttons = [];
    var
      crawler = FilerTreeCache.get(metaId).parentFolder;
    while(crawler.parentFolder){
      buttons.push({onclick:'controllerselect|'+crawler.metaId,emoji:crawler.emoji,svg:crawler.emoji?undefined:Icons.filer.folder_colored.withColor(crawler.color),title :crawler.name});
      crawler = crawler.parentFolder;
    }
    return {'menu':buttons}
  }

})

type FolderCreateForm = HTMLFormElement & {
  parentFolderId:HTMLInputElement
  emoji:HTMLInputElement
  name:HTMLInputElement
  color:HTMLInputElement
  sharedToAll:HTMLInputElement
  sharedMemberIds:HTMLSelectElement
}
type FileEditForm = HTMLFormElement & {
  name:HTMLInputElement
}

Html.registerDom({
  fileropenfeedback:async function(){
    var TPL_FEEDBACK = await import("../modal/feedbacks.mustache");
    modal.openDomModal(TPL_FEEDBACK,{description:'feedback.filer',type:"FILER"})
  },

  async foldersort(value){
    amplify.publishAsync('filerNeedRefresh');
    await MultiplexApi.filerputfolder(new FolderInputBean({
      filerSorting:value as FilerSortingEnum,
      metaId:Html.getDomMetaId(this)
    }))


  },
  async folderview(value){
    amplify.publishAsync('filerNeedRefresh');
    await MultiplexApi.filerputfolder(new FolderInputBean({
      filerDisplayMode:value as FilerDisplayModeEnum,
      metaId:Html.getDomMetaId(this)
    }))
  },
  async foldercreate(parentId){
    const
      TPL = await import('./folder_edit.mustache'),
      parentFolder = parentId?FilerTreeCache.get(parentId) as FolderBean:FilerTreeCache.getRoot(),
      theModal = modal.openDomModal(TPL,{
        parentFolderId:parentFolder.metaId,
        isSubFolder:parentId!==undefined && parentId!==FilerTreeCache.getRoot().metaId,
        sharingType:parentFolder.sharingType,
        sharedToAll:parentFolder.sharedToAll,
        authorIsMe:true
      }),
      form = theModal.querySelector('form') as FolderCreateForm;
    
    form.addEventListener('submit', async function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!validate(form)){
        return false;
      }
      amplify.publishAsync('filerNeedRefresh');
      
      const folder = await MultiplexApi.filerputfolder(new FolderInputBean({
        parentFolderId:parentFolder.metaId,
        emoji:form.emoji?.value,
        name:form.name?.value,
        color:form.color?.value,
        sharedToAll:form.sharedToAll?.value,
        sharedMemberIds:Array.from(form.sharedMemberIds?.selectedOptions || []).map(option => option.value)
      }))
      modal.toastDone('files.toastfoldercreated',folder)
      modal.closeDomModal();
      
    });
  },
  async folderedit(){
    const
      folder = FilerTreeCache.get(Html.getDomMetaId(this)) as FolderBean,
      TPL = await import('./folder_edit.mustache'),
      theModal = modal.openDomModal(TPL,folder),
      form = theModal.querySelector('form') as FolderCreateForm;

    form.addEventListener('submit', async function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!validate(form)){
        return false;
      }
      amplify.publishAsync('filerNeedRefresh');
      const updatedFolder = await MultiplexApi.filerputfolder(new FolderInputBean({
        metaId : folder.metaId,  
        parentFolderId:folder.parentFolderId,
        emoji:form.emoji?.value,
        name:form.name?.value,
        color:form.color?.value,
        sharedToAll:form.sharedToAll?.value,
        sharedMemberIds:Array.from(form.sharedMemberIds?.selectedOptions || []).map(option => option.value)
      }))
      modal.toastDone('files.toastfolderupdated',updatedFolder)
      modal.closeDomModal();
    });
  },
  async folderdelete(){
    const
      folder = FilerTreeCache.get(Html.getDomMetaId(this));

    if(!await modal.confirmDelete("files.confirmdeletefolder")) return;
    modal.closeDomModal()
    amplify.publishAsync('filerNeedRefresh');
    await MultiplexApi.filerdeletefolder([folder.metaId])
    modal.toastDone('files.toastfolderdeleted',folder)

  },
  async foldermove(){
    const
      metaId = Html.getDomMetaId(this),
      folder = FilerTreeCache.get(metaId) as FolderBean,
      targetFolder = await pickFolder({title:"actions.move",canPickRoot:true})

    if(!targetFolder) return;

    if(targetFolder===folder){
      modal.oops(i18n.get('files.errors.move_folder_into_itself',folder.name))
      return;
    }

    if(targetFolder.getPath().indexOf(folder)>-1){
      modal.oops(i18n.get('files.errors.move_folder_into_subfolder',folder.name))
      return;
    }
    let creator = FwDatas.getProfile();
    if(targetFolder.parentFolderId!==undefined){
      if(creator.accountId!==folder.accountId && !sameSet(folder.sharedMembers(),targetFolder.sharedMembers())) {
        modal.oops(i18n.get('files.errors.move_folder_different_sharing',{folderName:folder.name,creatorName:creator.firstName}))
        return;
      }

    }
    if(targetFolder && targetFolder!==folder){
      amplify.publishAsync('filerNeedRefresh');
      const updatedFolder = await MultiplexApi.filerputfolder(new FolderInputBean({
        metaId,
        parentFolderId:targetFolder.metaId
      }))
      modal.toastDone('files.toastfoldermoved',updatedFolder)
      
    }
  },
  async folderduplicate(){
    if(!await Medias.checkQuota()) return;
    const
      metaId = Html.getDomMetaId(this),
      folder = FilerTreeCache.get(metaId),
      targetFolder = await pickFolder({title:"actions.copy",canPickRoot:true})

    if(!targetFolder) return;

    if(targetFolder){
      amplify.publishAsync('filerNeedRefresh');
      const duplicatedFolder = await MultiplexApi.filerduplicatefolder(
        metaId,
        targetFolder.metaId
      )
      modal.toastDone('files.toastfolderduplicated',duplicatedFolder);
    }

  },
  async filemove(){
    const
      metaId = Html.getDomMetaId(this),
      file = FilerTreeCache.get(metaId),
      targetFolder = await pickFolder({title:"actions.move"})

    if(targetFolder && targetFolder!==file.parentFolder){
      fileViewer.close()
      amplify.publishAsync('filerNeedRefresh');
      const updatedFile = await MultiplexApi.filerputfile(new IFilerInputBean({
        metaId,
        parentFolderId:targetFolder.metaId
      }))
      modal.toastDone('files.toastfilemoved',updatedFile)
      
    }
  },

  async fileedit(){
    const
      file = FilerTreeCache.get(Html.getDomMetaId(this)),
      dotIdx = file.name.lastIndexOf('.'),
      name = (dotIdx===-1)?file.name:file.name.substring(0,dotIdx),
      extension = (dotIdx===-1)?'':file.name.substring(dotIdx),
      TPL = await import('./file_edit.mustache'),
      theModal = modal.openDomModal(TPL,{metaId:file.metaId,name,extension}),
      form = theModal.querySelector('form') as FileEditForm;

    form.addEventListener('submit', async function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!validate(form)){
        return false;
      }
      fileViewer.close()
      amplify.publishAsync('filerNeedRefresh');
      const updatedFile = await MultiplexApi.filerputfile(new IFilerInputBean({
        metaId:file.metaId,
        name:form.name.value+extension
      }))
      modal.toastDone('files.toastfileupdated',updatedFile)
      modal.closeDomModal();
      
    });
  },

  async fileduplicate(){
    if(!await Medias.checkQuota()) return;
    const
      metaId = Html.getDomMetaId(this),
      file = FilerTreeCache.get(metaId) as IMedia,
      targetFolder = await pickFolder({title:"actions.copyto"});
    if(targetFolder){
      amplify.publishAsync('filerNeedRefresh');
      await MultiplexApi.filerputfile(new IFilerInputBean({
        parentFolderId:targetFolder.metaId,
      }),file.pictureUrl)
      modal.toastDone('files.toastfileduplicated',file)
      amplify.publish('filerNeedRefresh');
    }
  },
  async fileupload(){
    if(!await Medias.checkQuota()) return;
    var
      parentFolderId = Html.getDomMetaId(this),
      files = await pickFileFromDevice("*/*",true)

    upload(parentFolderId,files)

  }

})